module.exports = __webpack_public_path__ + "img/Ketchup.97d84566.webp";